import {
  makeModalResponsive,
  featureEnabled,
  isContextualChatEnabled,
} from 'utils';
import { Modal } from 'components';
import template from './listing_buttons.html';

// Need to implement logic to show and hide buttons based on auth;
angular.module('bb.listing_view').directive('listingButtons', () => {
  return {
    restrict: 'E',
    scope: {
      listing: '<',
    },
    controller: ListingButtonsController,
    bindToController: true,
    controllerAs: 'vm',
    template,
  };
});

ListingButtonsController.$inject = [
  '$scope',
  'ListingViewService',
  '$rootScope',
];
function ListingButtonsController($scope, ListingViewService, $rootScope) {
  const vm = this;
  vm.editListing = () => {
    const isMls = vm.listing.mls_numbers?.length > 0;
    if (isMls) {
      makeModalResponsive(
        Modal.confirm({
          title: 'Edit Listing',
          okText: 'Continue',
          content:
            'Changes made to listings on BrokerBay will be overridden by information on the MLS. ' +
            'The Listing Agent field is exempt from this override. Are you sure you want to continue?',
          onOk: () => {
            window.location.href = `#/listing/${vm.listing.id}/edit/`;
          },
          centered: true,
        }),
        { dataCys: { content: 'confirm-edit-listing-modal' } },
      );
    } else {
      window.location.href = `#/listing/${vm.listing.id}/edit/`;
    }
  };

  vm.isAssumed =
    Boolean(
      $rootScope.auth?.assumingUserId || $rootScope.auth?.isAssumedNotBB,
    ) && $rootScope.auth?.org?.id === vm.listing?.org.id;

  vm.canEdit = () =>
    vm.isAssumed || featureEnabled('supraHideAdminFunctionalityFeature')
      ? (vm.hasFeature('SUPRA_MVP') &&
          ($rootScope.auth?.org.country === 'CAN' ||
            $rootScope.auth?.parentOrgType === 'mlsStaff')) ||
        !this.hasFeature('SUPRA_MVP')
      : true;

  vm.hasFeature = feature =>
    vm.isAssumed || vm.listing.org.features.includes(feature);

  vm.hasContextualChat = () =>
    vm.listing.org.features.includes('CHAT') &&
    isContextualChatEnabled($rootScope.auth?.org.mlsTypes);

  $scope.$watch('vm.listing.id', listingId => {
    vm.listingId = listingId;
    if (vm.hasFeature('OFFERS') && vm.hasFeature('APPOINTMENT'))
      ListingViewService.getOfferCount(vm.listingId).then(({ count }) => {
        vm.offersCount = count;
      });
    ListingViewService.getAppointmentCount(vm.listingId).then(
      ({ newAppointments }) => {
        vm.aptCount = newAppointments;
      },
    );
    vm.showingsPath = `#/listing/${listingId}/showings/`;
  });

  $scope.$watch('vm.listing.documentStatus', documentStatus => {
    vm.listingRejected =
      !$rootScope.auth.isAdmin && documentStatus === 'rejected';
    vm.listingPending = $rootScope.auth.isAdmin && documentStatus === 'pending';
  });
}
